
import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { SharedService } from '../shared.service';
import { NgClass } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { GdcNavbarComponent } from './gdc-navbar/gdc-navbar.component';
import { GdcSidebarComponent } from './gdc-sidebar/gdc-sidebar.component';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-content-layout-gdc',
    imports: [
      NgClass,
      RouterOutlet,
      GdcNavbarComponent,
      GdcSidebarComponent
    ],
    templateUrl: './content-layout-gdc.component.html',
    styleUrl: './content-layout-gdc.component.scss',})

export class ContentLayoutGdcComponent {
  title = 'vas-project';
  isCollasepedflag:boolean=JSON.parse(localStorage.getItem('isCollasepedflag') || 'false');
  @Output() isCollaseped = new EventEmitter<boolean>(false);
  
  isExpanded: boolean = false;   // For expanded layout
  isHover: boolean = false;      // For hover case
  isMobile: boolean = false;
  isMobileView:boolean=false;
  isMobileSearch:boolean=false;
  MENUITEMS: any[] = [
    {
      HeaderTitle:'Dashboard'
    },
    {
      title: 'Dashboard',
      icon: 'home',
      type: 'sub',
      active: true,
      User:'both',
      children: [
        { path: '/dashboard/dashboard01', title: 'Dashboard01', type: 'link',  active: true, },
        { path: '/dashboard/dashboard02', title: 'Dashboard02', type: 'link',  active: false, },
      ],
    },
	 {
      title: 'Pipeline',
      icon: 'home',
      type: 'sub',
      active: false,
      User:'both',
      children: [
        { path: '/dealer/pipeline/', title: 'Pipeline List', type: 'link',active: false, },
        { path: '/dashboard/dashboard02', title: 'Order2', type: 'link',active: false, },
      ],
   },
   { path: '/dashboard/dashboard01', title: 'VAS Product', type: 'link',active: false, },
	]
  constructor(private sharedService:SharedService) { }
       // For mobile view case
  ngOnInit() {
    // Detect mobile view on page load
    this.detectMobileView(false);

    // Optionally listen for window resize events
    window.addEventListener('resize', () => {
      this.detectMobileView(false);
    });
    this.sharedService.toggleState$.subscribe((value: boolean) => {
      this.isMobile = value;
    });
  }
  ngDocheck(){
    this.detectMobileView(false);
    // Optionally listen for window resize events
    window.addEventListener('resize', () => {
      this.detectMobileView(false);
    });
  }
  toggleExpanded() {
    this.isExpanded = !this.isExpanded;
  }
  mouseOverleave(){
   this.isHover=!this.isExpanded;
  }
  // You can detect mobile view using screen size
  detectMobileView(val:boolean) {
    this.isMobile=val;
    this.isMobileView = window.innerWidth <= 1026; 
  }
  getActivemenu(item:any):any{
    item.isOpen = !item.isOpen;
  }
  getActiveChild(parent: any, child: any, event: Event) {
    console.log(parent,'parent')
    this.MENUITEMS?.forEach(menuItem => {
      menuItem.active = false
      if (menuItem?.children) {
        menuItem.children.forEach((childItem: any) => childItem.active = false);
      }
    });
   // Prevent parent click event from firing
    event.stopPropagation();
  // Reset all child items of the clicked parent
    parent?.children?.forEach((childItem: any) => childItem.active = false);
  // Set the clicked child item to active
    child.active = true;
 // Ensure the parent is also set to active
   parent.active = true;
  }
  SerachMbInfo()
  {
    this.isMobileSearch=!this.isMobileSearch
  }
  togglecollapsedScreen(isCollaseped: boolean){
    if (this.isMobileView) {
     this.isCollasepedflag=false
   } else {
     this.isCollasepedflag = !isCollaseped;
     this.sharedService.gettoggleSidebar(this.isCollasepedflag)
     this.isCollaseped.emit(this.isCollasepedflag);
   }
 }
}